export enum variantOptions {
  neutral = "neutral",
  secondary = "secondary",
  ghost = "ghost",
}
